import { ChangeNotifier } from "subtree.js/core";

/**
 * How many customer carts wait on the merchant: the badge in the shell. Marked
 * stale by the carts page after an approve, reject or edit; the shell reloads.
 */
export class PendingCartsRepository extends ChangeNotifier {
  #count = 0;
  /** The counter the count was read for: another counter's is none of this one's. */
  #entry: string | null = null;
  #stale = false;

  /** The count read for `entry` (a store, or `loc_<id>`), else none. */
  countFor(entry: string): number {
    return entry === this.#entry ? this.#count : 0;
  }

  get isStale(): boolean {
    return this.#stale;
  }

  setCount(count: number, entry: string): void {
    const changed = this.#stale || this.#count !== count || this.#entry !== entry;
    this.#stale = false;
    this.#count = count;
    this.#entry = entry;
    if (changed) this.notifyListeners();
  }

  markStale(): void {
    if (this.#stale) return;
    this.#stale = true;
    this.notifyListeners();
  }

  reset(): void {
    this.#count = 0;
    this.#entry = null;
    this.#stale = false;
    this.notifyListeners();
  }
}
